import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'PickupPass';

const PickupPassesPassApi: any = baseApi(endpoint);

export default PickupPassesPassApi;